import styled from "styled-components";

const FooterWrapper = styled.footer`
  .main-footer {
    padding: 70px 0 0px;
    background: #0c0a0b;
    width: 100%;
    @media (max-width: 1000px) {
      padding: 70px 20px 0px;
    }
  }
  ul {
    padding-left: 0;
    list-style: none;
    li {
      font-size: 16px;
      margin-bottom: 10px;
    }
  }

  /* Copy Right Footer */
  .footer-copyright {
    background: #000;
    padding: 5px 0;
  }
  .footer-copyright .logo {
    display: inherit;
  }
  .footer-copyright nav {
    float: right;
    margin-top: 5px;
  }
  .footer-copyright nav ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .footer-copyright nav ul li {
    border-left: 1px solid #505050;
    display: inline-block;
    line-height: 12px;
    margin: 0;
    padding: 0 8px;
  }
  .footer-copyright nav ul li a {
    color: #fff;
    font-size: 16px;
  }
  .footer-copyright nav ul li:first-child {
    border: medium none;
    padding-left: 0;
  }
  .footer-copyright p {
    color: #fff;
    font-size: 16px;
    margin: 2px 0 0;
  }

  /* Footer Top */
  .footer-top {
    background: #252525;
    padding-bottom: 30px;
    margin-bottom: 30px;
    border-bottom: 3px solid #222;
  }

  /* Footer transparent */
  .transparent .footer-top,
  .transparent .main-footer {
    background: transparent;
  }
  .transparent .footer-copyright {
    background: none repeat scroll 0 0 rgba(0, 0, 0, 0.3);
  }

  /* Footer 4 */
  .footer- .logo {
    display: inline-block;
  }

  /*==================== 
	Widgets 
====================== */
  .widget {
    padding: 20px;
    margin-bottom: 40px;
  }
  .widget.no-box {
    padding: 0;
    background-color: transparent;
    margin-bottom: 40px;
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    -ms-box-shadow: none;
    -o-box-shadow: none;
    a {
      color: #fff;
      font-weight: 400;
      text-decoration: none;
      &:hover {
        color: #0d6efd;
      }
    }
  }
  .widget li a {
    color: #fff;
    text-decoration: none;
  }
  .widget li a:hover {
    color: #fff;
    text-decoration: underline;
  }
  .widget-title {
    margin-bottom: 20px;
    font-weight: 900;
    img {
      width: 100px;
    }
  }
  .widget-title span {
    background: #839fad none repeat scroll 0 0;
    display: block;
    height: 1px;
    margin-top: 25px;
    position: relative;
    width: 20%;
  }
  .widget-title span::after {
    background: inherit;
    content: "";
    height: inherit;
    position: absolute;
    top: -4px;
    width: 50%;
  }
  .widget-title.text-center span,
  .widget-title.text-center span::after {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
  }
  .widget .badge {
    float: right;
    background: #7f7f7f;
  }

  p.footer-description {
    line-height: 30px;
  }

  .typo-light h1,
  .typo-light h2,
  .typo-light h3,
  .typo-light h4,
  .typo-light h5,
  .typo-light h6,
  .typo-light p,
  .typo-light div,
  .typo-light span,
  .typo-light small {
    color: #fff;
  }

  ul.social-footer2 {
    margin: 0;
    padding: 0;
    width: auto;
  }
  ul.social-footer2 li {
    display: inline-block;
    padding: 0;
  }
  ul.social-footer2 li a {
    display: block;
    height: 30px;
    width: 30px;
    margin: 0px 20px 0px 0px;
    text-align: center;
    border-radius: 50%;
  }
`;

export { FooterWrapper };
